// navigation/client.js
// Event handlers for the site nav and menu.
import $ from 'jquery';
import _ from 'lodash';
import radio from 'radio';
import viewport from 'lib-unicorn/viewport';
import {
  scrolledDownPast,
  scrolledUpWithVelocity,
  scrolledBelowElement } from 'lib-unicorn/scroll-utils';
import {
  CLICK,
  SCROLL,
  TOUCHMOVE,
  TOUCHSTART,
  MOUSEOVER,
  NAV_MOVED } from 'shared/enums/events';

export default function navigationClient() {
  const $body = $('body');
  const $nav = $('nav.main');
  const $menu = $('nav.menu');
  const $search = $nav.find('.icon.search.js-activate');
  const $searchNavOpen = $nav.find('.icon.search-nav.js-activate');
  const $closeSearch = $nav.find('.icon.close-search');
  const $searchField = $nav.find('.search-field');
  const $menuButton = $nav.find('.menu');
  const $menuOverlay = $body.find('.menu-overlay');
  const $menuCloseButton = $nav.find('.icon.menu-close');
  const $sidebarMenu = $('.sidebar-overlay-menu');
  const $allSubmenus = $menu.find('li.has-submenu');
  const $titleDisplay = $('.title-display');
  const titleDisplayWidth = Math.ceil($titleDisplay.width());
  const scrolledBelowShare = scrolledBelowElement($('.article .share'));
  const targetIs = ($target, $test) => $target.is($test) || ($test.has($target).length > 0);
  let navMovedInProgress = false;
  const triggerNavMoved = () => {
    if (!navMovedInProgress) {
      navMovedInProgress = true;
      setTimeout(() => {
        radio(NAV_MOVED).broadcast();
        navMovedInProgress = false;
      }, 200);
    }
  };

  // Prevent flashes of animation on page load.
  _.defer(() => $('nav.main, nav.menu').addClass('can-animate'));

  // Fix an issue with blurry text on chrome and safari.
  $titleDisplay.width(titleDisplayWidth + (titleDisplayWidth % 2));

  // Handle clicks on the UI.
  radio(CLICK).subscribe((event, $target) => {
    // Open the search field.
    if (targetIs($target, $search) && !$nav.hasClass('search-open')) {
      $nav.addClass('search-open');
      return $searchField.prop('disabled', false).focus();
    // Close the search field.
    } else if (targetIs($target, $search) ||
    targetIs($target, $closeSearch)) {
      $nav.removeClass('search-open');
      return $searchField.blur().prop('disabled', true);
    // Open the menu.
    } else if (targetIs($target, $searchNavOpen)) {
      $searchNavOpen.addClass('search-nav-open'); // Hide the search icon.
      $searchField.focus();   // Focus the search textbox.
      return $body.toggleClass('menu-active'); // Open the menu.
    } else if (targetIs($target, $menuButton) ||
    targetIs($target, $menuCloseButton)) {
      if ($nav.find('.search-nav-open').length > 0) {
        $searchNavOpen.removeClass('search-nav-open'); // Show the search icon.
      } else {
        $searchNavOpen.addClass('search-nav-open'); // Hide the search icon.
      }
      return $body.toggleClass('menu-active');
    } else if (targetIs($target, $menuOverlay)) {
      return $body.removeClass('menu-active');
    // Open the submenu accordion.
    } else if ($target.hasClass('has-submenu')) {
      return $target.toggleClass('submenu-active');
    // Close the submenu accordion.
    } else if ($target.parents('.has-submenu').length > 0) {
      return $target.parents('.menu-item').toggleClass('submenu-active');
    }
    return null;
  });

  // Hide certain menu items on scroll.
  radio(SCROLL).subscribe(() => {
    if ($('.tgx-sticky-header-wrapper').length > 0) {
      triggerNavMoved();
      return false;
    }
    if (scrolledDownPast(150)) {
      if (!$nav.hasClass('hide-nav-elements')) {
        $nav.addClass('hide-nav-elements');
        $menu.addClass('hide-nav-elements');
        triggerNavMoved();
      }
    } else if (scrolledUpWithVelocity(30) || ($(window).scrollTop() < 150)) {
      if ($nav.hasClass('hide-nav-elements')) {
        $nav.removeClass('hide-nav-elements');
        $menu.removeClass('hide-nav-elements');
        triggerNavMoved();
      }
    }

    if (scrolledBelowShare()) {
      return $body.addClass('under-social');
    }
    return $body.removeClass('under-social');
  });

  // Event handlers for the sidebar menu.
  radio(MOUSEOVER).subscribe((event, $target) => {
    // On mobile devices we don't want mouseover events at all.
    if (viewport().isMobile()) {
      return;
    }

    // If the target doesn't have a submenu, hide the submenu.
    if (($target.parents('.sidebar-overlay-menu').length === 0) &&
    ($target.parents('li.has-submenu').length === 0) &&
    !$target.hasClass('sidebar-overlay-menu') &&
    !$target.hasClass('has-submenu') &&
    !$target.is($menu)) {
      $sidebarMenu.addClass('hidden');
      $allSubmenus.removeClass('hilighted');
      return;
    }

    // Move the submenu next to the list item and transfer its
    // content.
    if ($target.parents('nav.menu').length > 0) {
      let $listItem;
      if ($target.parents('li.has-submenu').length > 0) {
        $sidebarMenu.removeClass('hidden');
        $listItem = $target.parents('li.has-submenu');
      } else if ($target.hasClass('has-submenu')) {
        $sidebarMenu.removeClass('hidden');
        $listItem = $target;
      }

      $allSubmenus.removeClass('hilighted');
      $listItem.addClass('hilighted');

      $sidebarMenu.html($listItem.find('.submenu').clone());
      let top = $listItem.offset().top - window.pageYOffset;

      // Make sure the sidebar popup menu is always completely in view.
      if (top > (($(window).height() - $sidebarMenu.height()) + 9)) {
        top = ($(window).height() - $sidebarMenu.height()) + 9;
      }

      $sidebarMenu.css('top', top);
    }
  });

  // Prevent overscrolls on mobile.
  // @see http://bit.ly/1TLWLaP
  radio(TOUCHSTART).subscribe((event) => {
    const menu = $menu.get(0);
    const top = menu.scrollTop;
    const totalScroll = menu.scrollHeight;
    const currentScroll = top + menu.offsetHeight;

    if (top === 0) {
      menu.scrollTop = 2;
    } else if (currentScroll === totalScroll) {
      menu.scrollTop = top - 2;
    }

    // Close the menu if we touch the edge of the screen.
    if ((event.originalEvent.pageX > $menu.width()) &&
    (event.originalEvent.pageY > $nav.height()) &&
    $body.hasClass('menu-active')) {
      $body.removeClass('menu-active');
      return event.preventDefault();
    }

    return event;
  });

  // Ignore touches to the background while the menu is open.
  radio(TOUCHMOVE).subscribe((event, $target) => {
    if ($body.hasClass('menu-active') &&
    ($target.parents('nav.menu').length === 0)) {
      return event.preventDefault();
    }
    return event;
  });
}



// WEBPACK FOOTER //
// ./~/unicorn/shared/components/navigation/client.js